import React, {useMemo} from 'react';
import cn from 'classnames';

import Skeleton from 'coreComponents/Skeleton';

import Carousel from 'brandComponents/Carousel';

import {defaultCarouselConfig} from './config';
import {ICarouselContentfulProps} from './ICarouselContentful';

// eslint-disable-next-line no-restricted-imports
import './CarouselContentful.scss';

const fallbackScrollBarConfig = {
	hide: false,
	dragSize: 'auto',
	draggable: true
};

const CarouselContentful = (props: ICarouselContentfulProps) => {
	const carouselSlides = useMemo(() => {
		const itemsArr = props?.itemsCollection?.reactElements || [];

		return itemsArr.map((item, index) => {
			return {
				key: `carousel-item-${item?.sys?.id || new Date().getTime()}-${Math.random()}-${index}`,
				elem: item,
			};
		});
	}, []);

	const carouselConfig = useMemo(
		() => ({
			...defaultCarouselConfig,
			autoplay:
				(props?.autoplay && {
					delay: props?.autoplayTimeout || 6000,
					disableOnInteraction: false,
				}) ||
				false,
			loop: props?.loop || false,
			slidesPerView: props?.slidesPerView || 'auto',
			navigationConfig: {enabled: props?.enableNavigation || false},
			breakpoints: props?.breakpoints || {},
			paginationConfig:
				props?.enablePagination && {
					enabled: true,
					type: props?.enablePaginationNumbers ? 'fraction' : 'bullets',
				} || {enabled: false},
			scrollBarConfig: props?.enableScrollBar ? (props.scrollBarConfig ?? fallbackScrollBarConfig) : undefined,
			spaceBetween: props?.spaceBetween ?? defaultCarouselConfig.spaceBetween,
			rewind: props?.rewind,
			slidesOffsetBefore: props.slidesOffsetBefore,
			slidesOffsetAfter: props.slidesOffsetAfter,
			freeMode:
				props?.effect === 'freeMode' && {
					enabled: true,
					sticky: true,
					momentum: false,
					momentumBounce: false,
				} || {enabled: false},
			resistanceRatio: props?.resistanceRatio,
		}),
		[],
	);

	const carouselStyle = {
		'--carousel-timeout': props?.autoplay
			? props?.autoplayTimeout
				? `${props?.autoplayTimeout}ms`
				: '6000ms'
			: '0ms',
		'--pagination-color': props?.paginationColor,
		'--background-pagination-color': props.backgroundPaginationColor || 'trasparent',
		'--slides': carouselSlides.length,
	} as React.CSSProperties;

	if (!carouselSlides.length || !carouselConfig) {
		return <Skeleton height="300px" width="100%" />;
	}

	return (
		<div className="cf-carousel" style={carouselStyle}>
			<Carousel
				config={carouselConfig}
				classNames={{
					swiper: cn({[`pagination-${props.paginationPosition}`]: props?.paginationPosition}),
				}}
			>
				{carouselSlides}
			</Carousel>
		</div>
	);
};

export default CarouselContentful;
